var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 61,
    viewBox: "0 0 47 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4034 23.9666C33.4034 18.8475 29.2533 14.6975 24.1343 14.6975C19.0143 14.6975 14.8643 18.8475 14.8643 23.9666C14.8643 29.0856 19.0143 33.2366 24.1343 33.2366C29.2533 33.2366 33.4034 29.0856 33.4034 23.9666Z",
    stroke: "#F57F20",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5883 8.1543C15.1558 8.1543 8.3208 14.5017 8.3208 22.3313",
    stroke: "#F57F20",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3992 23.4218C45.3992 11.3767 35.6338 1.61108 23.5889 1.61108C11.5432 1.61108 1.77783 11.3767 1.77783 23.4218C1.77783 35.4676 11.5432 45.2325 23.5889 45.2325C35.6338 45.2325 45.3992 35.4676 45.3992 23.4218Z",
    stroke: "#F57F20",
    strokeWidth: 1.62
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5886 45.2324V58.2786",
    stroke: "#F57F20",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14014 59.3494H43.2183",
    stroke: "#F57F20",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.91f06143ca7cd46f7ba081bc91079a07.svg";
export { ForwardRef as ReactComponent };